import '@/bootstrap';
import Vue from 'vue';
import store from '@/store';
import config from '@/config';

// Create axios instance (baseURL from centralized config so the same build can target different backends)
const service = window.axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 60000, // Request timeout
  withCredentials: true,
});

// Request intercepter
service.interceptors.request.use(
  configReq => {
    /* API key (app key for this app frontend) – required when backend enforces API keys */
    const apiKey = config.apiKey;
    if (apiKey) {
      configReq.headers['X-Api-Key'] = apiKey;
    }
    /* set the token for the auth-headers */
    const token = store.getters['getToken'];
    if (token) {
      configReq.headers['Authorization'] = 'Bearer ' + token;
      configReq.headers['X-Authorization'] = 'Bearer ' + token;
    }
    return configReq;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    // if (response.headers.authorization) {
    //   setLogged(response.headers.authorization);
    //   response.data.token = response.headers.authorization;
    // }

    return response.data;
  },
  error => {
    console.log(error);
    let message = error.message;
    if (error.response.data && error.response.data.errors) {
      message = error.response.data.errors;
    } else if (error.response.data && error.response.data.error) {
      message = error.response.data.error;
    }
    if (error.response.status == '404') {
      window.location.href = '/404';
    }

    var errortype = error.response && error.response.status;
    var theUser = store.state.user;
    /* 401: do not logout when the failure is invalid/missing API key (no user session involved) */
    if (errortype === 401) {
      var data = error.response && error.response.data;
      var isApiKeyError = (data && (data.error === 'Invalid or missing API key.' || data.message === 'Invalid or missing API key.'));
      if (isApiKeyError) {
        if (typeof window !== 'undefined' && window.alert) {
          window.alert('API-Schlüssel fehlt oder ist ungültig. Bitte Konfiguration prüfen.');
        }
      } else if (theUser != null) {
        store.dispatch('logout');
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export default service;
